// extracted by mini-css-extract-plugin
module.exports = {"root":"review-page_root__R455W","list":"review-page_list__C4WWS","pagination":"review-page_pagination__HtW5y"};